import capitalize from "lodash/capitalize";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "src/components/Dialog";
import { StatefulLoadableButton } from "src/components/LoadableButton";
import usePrevious from "src/utils/usePrevious";

import { AddNewSalePlatformIntegrationButton } from "src/components/AddNewSalePlatformIntegrationDialog";

export interface ConfirmDialogProps {
  reconnect?: boolean;
  username?: string;
  onCancel: () => void;
  onConfirm: (bankAccountId?: string | undefined) => Promise<void>;
  platform?: string;
  showConnectSalePlatform?: boolean;
}

function ConfirmDialog({
  reconnect = false,
  platform: _platform,
  username,
  onCancel,
  onConfirm,
  showConnectSalePlatform = true,
}: ConfirmDialogProps) {
  const platformMemory = usePrevious(_platform);
  const platformRaw = _platform || platformMemory || "Poshmark";
  const platform = platformRaw
    .split("-")
    .map((p) => capitalize(p))
    .join(" ");
  const usernameMemory = usePrevious(username);
  const title = reconnect
    ? `Refresh ${platform} Integrations`
    : `Add ${platform} integration`;
  const content = reconnect
    ? `The ${platform} account "${
        username || usernameMemory
      }" will be reconnected.`
    : `The ${platform} account "${username || usernameMemory}" will be added.`;
  const button = reconnect ? "Connect" : "Add";
  return (
    <Dialog open={!!username} onClose={() => onCancel()}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Cancel</Button>
        {showConnectSalePlatform ? (
          <AddNewSalePlatformIntegrationButton
            onConnect={onConfirm}
            color="primary"
            platformName={platform}
          >
            {button}
          </AddNewSalePlatformIntegrationButton>
        ) : (
          <StatefulLoadableButton
            color="primary"
            variant="contained"
            onClick={async () => await onConfirm()}
          >
            Connect
          </StatefulLoadableButton>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
